import React from "react";
import Typography from "@material-ui/core/Typography";

export default function AboutPage() {
  return <Typography variant="h6">About PAGE</Typography>;
}
